<template>
  <div class="profile-completeness">
    <div class="progress-container">
      <span class="paragraph paragraph-bold">{{ label }}</span>
      <progress-bar :value="percentage"></progress-bar>
    </div>
    <router-link :to="{name: editRoute}" class="edit-icon" @click.native="editButtonClick">
      <svg-icon name="edit" width="16" height="16"></svg-icon>
    </router-link>
  </div>
</template>

<script>

import ProgressBar from 'top20common/components/ProgressBar';

export default {
  props: {
    label: String,
    percentage: Number,
    editRoute: String
  },
  methods: {
    editButtonClick() {
      this.$emit('click');
    }
  },
  components: {ProgressBar}
};
</script>

<style lang="scss" scoped>
.profile-completeness {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.edit-icon {
  cursor: pointer;

  /deep/ svg {
    fill: var(--secondary);
  }
}
</style>
